<template>
    <list-page icone="mdi-account" titulo="Usuário" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:corpo>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
            <template v-slot:[`item.actions`]="{ item }">

              <v-tooltip right v-if="item.nome !='MASTER'">
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip right v-if="item.nome !='MASTER' && item.nome !='GESTOR'">
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>

            </template>

            <template v-slot:[`item.foto`]="{ item }">
              <img v-if="item.foto" :src="`data:image/jpeg;base64,${item.foto}`" class="ma-2" style="max-height: 80px"/>
            </template>

          </v-data-table>

          <!-- <v-data-table :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td class="justify-center layout px-0">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </td>
                    <td>{{ item.nome }}</td>
                    <td>{{ item.email }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table> -->

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-usuario v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>

        </template>
    </list-page>
</template>
<script>
import Usuario from '../../../core/domain/geral/Usuario';
import UsuarioService from '../../../core/services/geral/UsuarioService';
import ListPage from "@/components/shared/ListPage";

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value:'actions', sortable: false  },
        { text: 'Foto', value: 'foto' },
        { text: 'Nome', value: 'nome' },
        { text: 'Email', value: 'email' }
      ],
      primeiraCarga: true
    }),
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    created() {
      this.service = new UsuarioService();
    },
    methods: {
      Novo(){
        this.NovoCadastro(new Usuario());
      },
      Editar(item){
        this.service.ObterPorId(item.id, "Permissoes").then(
          res =>{
            this.EditarCadastro(new Usuario(res.data));
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        )
      }
    }
}
</script>
